import React, { useRef } from 'react';
import './BillModal.css';

export default function BillModal({ isOpen, onClose, data }) {
    const billRef = useRef(null);
    if (!isOpen || !data) return null;

    const { date, receiptCode, receiver, items, total } = data;

    const handlePrint = () => {
        const printContent = billRef.current;
        if (!printContent) return;

        const printWindow = window.open(/*'', '_blank'*/ /*, 'width=400,height=600'*/);
        printWindow.document.write(`
            <!DOCTYPE html>
            <html dir="rtl">
            <head>
                <title>فاتورة - ${receiptCode}</title>
                <style>
                    body {
                        font-family: Arial, sans-serif;
                        padding: 20px;
                        direction: rtl;
                    }
                    .bill-header {
                        text-align: center;
                        border-bottom: 2px dashed #ccc;
                        padding-bottom: 15px;
                        margin-bottom: 20px;
                    }
                    .bill-header h2 {
                        margin: 0 0 10px 0;
                    }
                    .bill-meta {
                        display: flex;
                        justify-content: space-between;
                        font-size: 0.9rem;
                        color: #666;
                    }
                    .customer-info {
                        margin-bottom: 20px;
                        font-weight: bold;
                        font-size: 1.1rem;
                        border-bottom: 1px solid #eee;
                        padding-bottom: 10px;
                    }
                    table {
                        width: 100%;
                        border-collapse: collapse;
                        margin-bottom: 20px;
                    }
                    th, td {
                        text-align: right;
                        padding: 8px;
                        border-bottom: 1px solid #eee;
                    }
                    th {
                        background-color: #f9f9f9;
                        font-weight: bold;
                    }
                    .total-section {
                        display: flex;
                        justify-content: space-between;
                        border-top: 2px solid #333;
                        padding-top: 15px;
                        font-size: 1.3rem;
                        font-weight: bold;
                    }
                </style>
            </head>
            <body>
                ${printContent.innerHTML}
            </body>
            </html>
        `);
        printWindow.document.close();
        printWindow.focus();
        setTimeout(() => {
            printWindow.print();
            printWindow.close();
        }, 250);
    };

    return (
        <div className="bill-modal-overlay">
            <div className="bill-modal-content">
                <div ref={billRef}>
                    <div className="bill-header">
                        <h2>فاتورة مبيعات</h2>
                        <div className="bill-meta">
                            <span>التاريخ: {date}</span>
                            <span>رقم الإيصال: {receiptCode}</span>
                        </div>
                    </div>

                    <div className="customer-info">
                        السيد / السادة: {receiver}
                    </div>

                    <table className="bill-items-table">
                        <thead>
                            <tr>
                                <th>الصنف</th>
                                <th>الكمية</th>
                                <th>السعر</th>
                                <th>الإجمالي</th>
                            </tr>
                        </thead>
                        <tbody>
                            {items.map((item, index) => (
                                <tr key={index}>
                                    <td>{item.name}</td>
                                    <td>{item.qty}</td>
                                    <td>{item.unitPrice ? Math.round(parseFloat(item.unitPrice)).toLocaleString('en-US') : (item.price ? Math.round(parseFloat(item.price) / parseFloat(item.qty)).toLocaleString('en-US') : '-')}</td>
                                    <td>{item.price ? Math.round(parseFloat(item.price)).toLocaleString('en-US') : '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>

                    <div className="bill-total-section">
                        <span>الإجمالي النهائي:</span>
                        <span>{total}</span>
                    </div>
                </div>

                <div className="bill-actions">
                    <button className="bill-print-btn" onClick={handlePrint}>طباعة</button>
                    <button className="bill-close-btn" onClick={onClose}>إغلاق</button>
                </div>
            </div>
        </div>
    );
}
